import { render, staticRenderFns } from "./SGPConfirmacaoRestauracaoComponent.vue?vue&type=template&id=1e11b73e"
import script from "./SGPConfirmacaoRestauracaoComponent.vue?vue&type=script&lang=js"
export * from "./SGPConfirmacaoRestauracaoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports